// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"5b6754a5","969":"7d96b08f"}[chunkId] + ".chunk.js";
};